import styled from 'styled-components';
import { useChartContext } from '../../ChartContext';
import { getDisplayedMeasureLabel } from '../../ChartLegend/ChartMeasures/useFunnelSteps';
import { getMeasureColorFromColorConfig } from '../../utils/analysisColorConfig';
import { overflowingStyles } from '../../../../styles/shareableStyles';
import SegmentSelect from '../../../SegmentSelect';
import { YAxisPosition } from '../../interfaces';
import { setChartSettingsYAxisPositionAction } from '../../../../redux/slices/analyses';
import { useAppDispatch } from '../../../../redux/hooks';
import {
  AssignmentContainer,
  AssignmentRowWrapper,
} from '../CentralChartSettingUI';

const MeasureLabel = styled.span`
  display: flex;
  align-items: center;
  column-gap: 4px;
  width: 152px;
`;

const MeasureText = styled.span`
  ${overflowingStyles};
`;

const MeasureAssignments = () => {
  const dispatch = useAppDispatch();
  const {
    metadata: { analysisId },
    displayedMeasures,
    colorConfig,
  } = useChartContext();

  const yAxisPositionOptions = [
    { value: YAxisPosition.LEFT, label: 'Left' },
    { value: YAxisPosition.RIGHT, label: 'Right' },
  ];

  const onYAxisPositionChange = (
    measureKey: string,
    yAxisPosition: YAxisPosition,
  ) => {
    dispatch(
      setChartSettingsYAxisPositionAction({
        analysisId,
        measureKey,
        yAxisPosition,
      }),
    );
  };

  return (
    <AssignmentContainer>
      {displayedMeasures.map((measure) => {
        const color = getMeasureColorFromColorConfig(colorConfig, measure.key);

        return (
          <AssignmentRowWrapper
            key={measure.key}
            $isDisabled={!measure.isVisible}
          >
            <MeasureLabel>
              {getDisplayedMeasureLabel(measure, color)}
              <MeasureText>{measure.name}</MeasureText>
            </MeasureLabel>
            <SegmentSelect
              options={yAxisPositionOptions}
              value={measure.yAxisPosition ?? YAxisPosition.LEFT}
              onChange={(yAxisPosition) =>
                onYAxisPositionChange(measure.key, yAxisPosition)
              }
            />
          </AssignmentRowWrapper>
        );
      })}
    </AssignmentContainer>
  );
};

export default MeasureAssignments;
